import React from "react";

const Crm = () => {
  return (
    <div className="min-h-screen bg-slate-50 px-4 py-8 md:px-8">
      <div className="mx-auto max-w-6xl rounded-2xl bg-white shadow-lg overflow-hidden">
        <div className="bg-teal-700 p-6 md:p-8">
          <h1 className="text-3xl md:text-4xl font-bold text-white">CRM Development</h1>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4">
          <aside className="bg-teal-800 p-6 text-white lg:min-h-[420px]">
            <ul className="space-y-4 text-sm md:text-base">
              <li>Customer Relationship Management</li>
              <li>Sales Automation</li>
              <li>Lead Tracking</li>
              <li>Reporting & Analytics</li>
            </ul>
          </aside>

          <div className="lg:col-span-3 p-6 md:p-8">
            <h2 className="text-2xl md:text-3xl font-bold text-teal-700 mb-4">
              Build better customer relationships
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              We design CRM systems that help teams manage leads, track customer
              interactions, automate processes, and improve business performance.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="rounded-xl bg-slate-100 p-5">
                <h3 className="font-bold text-lg mb-2">Lead Capture</h3>
                <p className="text-slate-600 text-sm">Centralize incoming enquiries and streamline response handling.</p>
              </div>
              <div className="rounded-xl bg-slate-100 p-5">
                <h3 className="font-bold text-lg mb-2">Sales Workflow</h3>
                <p className="text-slate-600 text-sm">Automate follow-ups and keep your sales pipeline organized.</p>
              </div>
              <div className="rounded-xl bg-slate-100 p-5">
                <h3 className="font-bold text-lg mb-2">Insightful Reports</h3>
                <p className="text-slate-600 text-sm">Understand performance and make data-driven business decisions.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Crm;
